import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, History, TrendingUp, Settings, Stethoscope, FolderOpen, User, Menu, X } from 'lucide-react';

const EngineerSidebar = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const menuItems = [
    { path: '/engineer/dashboard', icon: Home, label: 'Dashboard' },
    { path: '/engineer/orders', icon: FileText, label: 'Tuning Files' },
    { path: '/engineer/consultings', icon: Stethoscope, label: 'Consultings' },
    { path: '/engineer/file-manager', icon: FolderOpen, label: 'Gestionnaire de fichiers' },
    { path: '/engineer/history', icon: History, label: 'Historique' },
    { path: '/engineer/stats', icon: TrendingUp, label: 'Statistiques' },
    { path: '/engineer/admin', icon: Settings, label: 'Administration' },
    { path: '/engineer/profile', icon: User, label: 'Mon Compte' },
  ];

  return (
    <>
      {/* Mobile hamburger toggle */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="engineer-sidebar-toggle"
        className="lg:hidden fixed top-20 left-4 z-30 bg-[#1a1a1a] border border-[#A6A6A6]/30 rounded-lg p-2 text-white shadow-lg"
        aria-label="Ouvrir le menu"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Backdrop */}
      {open && (
        <div
          className="lg:hidden fixed inset-0 z-40 bg-black/60 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed left-0 top-16 h-[calc(100vh-4rem)] w-64 bg-[#1a1a1a] border-r border-[#A6A6A6]/20 p-4 z-50
          transition-transform duration-300 ease-in-out
          ${open ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0`}
      >
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="lg:hidden absolute top-3 right-3 text-[#A6A6A6] hover:text-white"
          aria-label="Fermer le menu"
        >
          <X className="h-5 w-5" />
        </button>

        <nav className="space-y-2 mt-6 lg:mt-0">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                  isActive(item.path)
                    ? 'bg-[#C00000] text-white'
                    : 'text-[#A6A6A6] hover:bg-[#A6A6A6]/10 hover:text-white'
                }`}
              >
                <Icon className="h-5 w-5" />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default EngineerSidebar;
